import { jsx as _jsx } from "react/jsx-runtime";
import { CloseIcon } from '@bnb-chain/icons';
import { Button, forwardRef } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
export const ToastCloseButton = forwardRef((props, ref) => {
    return (_jsx(Button, { ref: ref, variant: "ghost", alignSelf: "center", minW: "auto", w: theme.sizes['6'], h: theme.sizes['6'], p: 0, borderRadius: "50%", sx: {
            svg: {
                w: theme.sizes['4'],
                h: theme.sizes['4'],
            },
        }, ...props, children: _jsx(CloseIcon, {}) }));
});
